import { AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'apc-section-anchors',
    templateUrl: './apc-section-anchors.component.html',
    styleUrls: ['./apc-section-anchors.component.scss'],
    standalone: false
})
export class ApcSectionAnchorsComponent implements AfterViewInit {

  @Input() public sections: any[];

  @ViewChild('anchorsSet') anchorsSet: ElementRef;
  sticky: boolean = false;
  anchorsPosition: any;
  defaultOffset = 130;

  constructor(private readonly router: Router, private readonly translate: TranslateService) { }

  scrollTo(divId) {
    let el = document.getElementById(divId);
    if (el) {
      let yPos = el.getBoundingClientRect().top;
      this.smoothScroll(yPos + window.pageYOffset, this.defaultOffset);
    }
  }
  
  smoothScroll(top, offset) {
    window.scrollTo({ top: top - offset, behavior: 'smooth' });
  }

  ngAfterViewInit() {
    this.anchorsPosition = window.innerWidth >= 1200 && window.innerWidth <= 1600 ? 280 : 310;
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll(event: Event) { 
    const windowScroll = globalThis.scrollY;
    this.sticky = windowScroll >= this.anchorsPosition;
  }

  getLabelClass(labelKey) {
    const labelLength = this.translate.instant(labelKey).length;
    let labelClass = "label-";

    if (labelLength < 5)
      labelClass += 'xs';
    else if (labelLength >= 5 && labelLength < 10)
      labelClass += 'sm';
    else if (labelLength >= 10 && labelLength < 15)
      labelClass += 'md';
    else if (labelLength >= 15 && labelLength < 30)
      labelClass += 'lg';
    else labelClass += 'xl';

    return labelClass;
  }

  changeUrl(anchor) {
    let fragments = window.location.pathname.split('/');
    let permission = this.sections.find(e => e.anchor == anchor).permission;
    let sectionIndex;
    fragments.forEach((f, i) => {
      if (f == permission.section) {
        sectionIndex = i;
      }
    });
    if (window.location.pathname.includes(permission.subsection)) {
      fragments[sectionIndex + 2] = '';
    }
    if (window.location.pathname.includes(permission.section)) {
      fragments[sectionIndex + 1] = permission.subsection;
    }
    if (fragments.length >= sectionIndex + 1) {
      fragments[sectionIndex + 1] = permission.subsection;
      fragments[sectionIndex + 2] = '';
    }
    window.history.replaceState({}, '', fragments.join('/'));
  }

}
